import { debounce } from "./debounce";

function init() {
  if (!document.querySelector(".get-reading-progress-bar")) return;

  //adds progress bar to dom
  function attachElToDom() {
    //create elements
    const elWrapper = document.createElement("div");
    const elBar = document.createElement("div");

    //add classes
    elWrapper.classList.add("progress__wrapper");
    elBar.classList.add("progress__bar");

    //attach to dom
    elWrapper.appendChild(elBar);
    document.body.prepend(elWrapper);
  }
  attachElToDom();

  function onScrollPageProgress() {
    const windowH = window.innerHeight;
    const target = document.querySelector("body");
    const { top, height } = target.getBoundingClientRect();

    const progress = (top, height, windowH) => {
      return Math.floor(((-windowH + top) / height) * -100);
    };

    return progress(top, height, windowH);
  }

  function setProgressVar() {
    const progressEl = document.querySelector(".progress__bar");
    progressEl.style.setProperty("--progress", `${onScrollPageProgress()}%`);
  }
  const returnedFunc = debounce(setProgressVar(), 100);
  window.addEventListener("scroll", setProgressVar);
}
window.addEventListener("load", init);
